"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const input_1 = __importDefault(require("../input"));
const input_styles_1 = require("../input.styles");
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const ErrorMap = {
    EMPTY_ERROR: 'This field is required',
    INVALID_PHONE: 'Enter a valid phone number',
};
const phoneRegex = new RegExp('^[6-9][0-9]{9}$', 'i');
const PhoneInput = (props) => {
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const [hasError, setHasError] = (0, react_1.useState)(true);
    const [errorMsg, setErrorMsg] = (0, react_1.useState)('');
    const [touched, setTouched] = (0, react_1.useState)(false);
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const handleOnChange = (event) => {
        setInputValue(`${event.target.value}`);
    };
    const handleValidation = () => {
        let errors = '';
        if (!inputValue) {
            setHasError(true);
            errors = ErrorMap.EMPTY_ERROR;
        }
        else if (phoneRegex.test(inputValue)) {
            setHasError(false);
        }
        else {
            setHasError(true);
            errors = ErrorMap.INVALID_PHONE;
        }
        if (errors && props.onError) {
            props.onError(inputValue, errors);
        }
        setErrorMsg(errors);
    };
    (0, react_1.useEffect)(() => {
        handleValidation();
    }, [inputValue]);
    return (react_1.default.createElement(input_1.default, Object.assign({}, props, { value: inputValue, onChange: handleOnChange, hasError: hasError && touched, errMsg: errorMsg, onBlur: () => {
            setTouched(true);
            handleValidation();
        }, leftElement: react_1.default.createElement(input_styles_1.CountryCodeText, { theme: theme, colors: colors }, "+91") })));
};
exports.default = PhoneInput;
//# sourceMappingURL=phone-input.js.map